export default "__VITE_ASSET__a031368d__"